export default "/images/vendor/flag-icon-css/flags/1x1/bt.svg?1372873ed65891680a2d0a4cf3a5d35c";